import React, { Fragment, useState, useEffect } from 'react';
import { NavMenu } from '../../navMenu/NavMenu';
import { IllustrationCreateEdit } from './IllustrationCreateEdit';
import { IllustrationDeleteModal } from './IllustrationDeleteModal';
import { ApiEndpoints } from '../../../api/apiEndpoints';
import { ListManager } from "react-beautiful-dnd-grid";
import './IllustrationsList.css';

export function IllustrationsList() {
    const assetInitialState = {
        id: '',
        description: '',
        sorting: 0,
        thumbnailFileName: '',
        originalFileName: '',
    };

    const [activeTab, setActiveTab] = useState('Portfolio');
    const [portfolioAssets, setPortfolioAssets] = useState([]);
    const [artAssets, setArtAssets] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentAsset, setCurrentAsset] = useState(assetInitialState);
    const [isEditing, setIsEditing] = useState(false);
    const [deleteAssetId, setDeleteAssetId] = useState(null);

    useEffect(() => {
        fetchPortfolio();
        fetchArt();
    }, []);

    const fetchPortfolio = async () => {
        const response = await fetch(`${ApiEndpoints.ManageIllustrations}?type=Portfolio`);
        const data = await response.json();
        setPortfolioAssets(data);
    };

    const fetchArt = async () => {
        const response = await fetch(`${ApiEndpoints.ManageIllustrations}?type=Art`);
        const data = await response.json();
        setArtAssets(data);
    };

    const fetchAssets = () => {
        if (activeTab === 'Portfolio') fetchPortfolio();
        else fetchArt();
    };

    const items = activeTab === 'Portfolio' ? portfolioAssets : artAssets;

    const handleCreate = () => {
        setCurrentAsset(assetInitialState);
        setIsEditing(false);
        setShowModal(true);
    };

    const handleEdit = (asset) => {
        setCurrentAsset(asset);
        setIsEditing(true);
        setShowModal(true);
    };

    const handleDelete = (id) => {
        setDeleteAssetId(id);
    };

    const handleDragEnd = (sourceIndex, destinationIndex) => {
        if (destinationIndex === null || sourceIndex === destinationIndex) {
            return;
        }

        const updatedItems = Array.from(items);
        const [movedItem] = updatedItems.splice(sourceIndex, 1);
        updatedItems.splice(destinationIndex, 0, movedItem);

        if (activeTab === 'Portfolio') setPortfolioAssets(updatedItems);
        else setArtAssets(updatedItems);

        var orderUpdates = [];
        let start = sourceIndex, end = destinationIndex;
        if (start > end) {
            const temp = start;
            start = end;
            end = temp;
        }

        for (let i = start; i <= end; i++) {
            orderUpdates.push({ id: updatedItems[i].id, newOrder: items[i].sorting });
        }

        if (orderUpdates.length > 0) {
            fetch(ApiEndpoints.ReorderIllustrations, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(orderUpdates),
            }).then(() => fetchAssets());
        }
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <Fragment>
            <div className="illustration-manager">
                <NavMenu />
                <section className="section-content padding-y">
                    <div className="container">
                        <div className="mb-3">
                            <button
                                className={`tab-btn ${activeTab === 'Portfolio' ? 'active' : ''}`}
                                onClick={() => handleTabClick('Portfolio')}
                            >
                                Portfolio
                            </button>
                            <button
                                className={`tab-btn ${activeTab === 'Art' ? 'active' : ''}`}
                                onClick={() => handleTabClick('Art')}
                            >
                                Art
                            </button>
                        </div>

                        <button className="btn btn-primary mb-3 pretty-font add-asset-btn" onClick={handleCreate}>
                            Add {activeTab} Image
                        </button>
                        <span className="mr-md-auto float-right pretty-font float-end">
                            {items.length} images
                        </span>

                        <div className="row col-lg-9 m-auto">
                            <ListManager
                                items={items}
                                direction="horizontal"
                                maxItems={4}
                                onDragEnd={handleDragEnd}
                                render={item => (
                                    <div
                                        className="illustration-item"
                                        onClick={() => handleEdit(item)}
                                    >
                                        <img
                                            src={ApiEndpoints.PublicFile + "/" + (item.thumbnailFileName || item.originalFileName)}
                                            alt={item.description || ''}
                                        />
                                        {item.description && (
                                            <div className="description-overlay">
                                                {item.description}
                                            </div>
                                        )}
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                </section>

                {showModal && (
                    <IllustrationCreateEdit
                        isEditing={isEditing}
                        setShowModal={setShowModal}
                        asset={currentAsset}
                        fetchAssets={fetchAssets}
                        handleDelete={handleDelete}
                        assetType={activeTab}
                    />
                )}

                {deleteAssetId && (
                    <IllustrationDeleteModal
                        deleteAssetId={deleteAssetId}
                        setDeleteAssetId={setDeleteAssetId}
                        fetchAssets={fetchAssets}
                    />
                )}
            </div>
        </Fragment>
    );
}
